import icons from '../icons'

const Tag = ({ name }) => {
    return <><li><icons.TagIcon/> {name}</li></>
}

export default Tag
